import index from './form-input'

export default index